import { Pipe, PipeTransform } from '@angular/core';
import { TeamInfo } from '../entities/team-info';
import { CHECK_POINTS } from '../constants';

export function globalCheckPointTransform(team: TeamInfo, point: string){
    const _value = team.checkpoints;
    const _index = CHECK_POINTS.indexOf(point);
    return _value[_index] === '1';
}

@Pipe({ name: 'globalCheckPoint' })
export class GlobalCheckPointPipe implements PipeTransform {
    transform(team: TeamInfo, point: string): boolean {
        return globalCheckPointTransform(team, point);
    }
}
